import { memo, type FC } from 'react';

import Typography from '../../../../Typography/index.ts';
import { dataTableNoData, dataTableSection } from '../../constants.ts';
import { useTableContext } from '../../context.tsx';
import { NoDataImage } from './Image.tsx';
import { NoDataWrapper } from './styled.ts';
import type { NoDataProps } from './types.ts';

export const NoData: FC<NoDataProps> = memo(function NoData({ className, message, action, image = <NoDataImage />, dataTestId }) {
  const { compact } = useTableContext();

  return (
    <NoDataWrapper
      className={className}
      $compact={compact}
      {...dataTableSection}
      {...dataTableNoData}
      data-testid={dataTestId ?? 'there-are-no-entries'}>
      {image}
      <Typography.Title>{message}</Typography.Title>
      {action || null}
    </NoDataWrapper>
  );
});
